import React, { useState, useEffect } from "react"
import { Box, TextField, Chip, Grid, Typography } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom"
import { CATEGORIES as defaultTags } from "../constants"
import queryString from "query-string"
import RecipeCard from "./recipeCard"

const SearchPage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  // Parse the query string to get the preSelectedTag, default to "Featured"
  const { tag: preSelectedTag = "Featured" } = queryString.parse(
    location.search
  )

  const [searchQuery, setSearchQuery] = useState("")
  const [selectedTag, setSelectedTag] = useState(preSelectedTag)
  const [tags, setTags] = useState(defaultTags)
  const [recipes, setRecipes] = useState([])

  useEffect(() => {
    // Add the preSelectedTag to the front of the tags list if it's not already there
    setTags((prevTags) => {
      if (
        !prevTags.includes(preSelectedTag) &&
        !defaultTags.includes(preSelectedTag)
      ) {
        return [preSelectedTag, ...prevTags]
      }
      return prevTags
    })

    setSelectedTag(preSelectedTag)
  }, [preSelectedTag])

  // Update the URL when the selected tag changes
  const handleTagChange = (tag) => {
    setSelectedTag(tag)
    navigate({
      search: `?tag=${encodeURIComponent(tag)}`, // Encode the tag
    })
  }

  // fetch recipes from backend
  useEffect(() => {
    const fetchRecipes = async () => {
      try {
        const response = await fetch("/api/recipes/")
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        const recipes = await response.json()
        setRecipes(recipes)
      } catch (error) {
        console.error("Error fetching recipes:", error)
      }
    }

    fetchRecipes()
  }, [])

  // Filter recipes based on search query and selected tag
  const filteredRecipes = recipes.filter((recipe) => {
    const matchesTag =
      selectedTag === "Featured" || recipe.selectedTags.includes(selectedTag)
    const matchesSearch = recipe.title
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
    return matchesTag && matchesSearch
  })

  return (
    <Box mt={4} p={2}>
      <TextField
        label="Search Recipes"
        variant="outlined"
        fullWidth
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.target.blur() // Deselect the TextField when pressing Enter
          }
        }}
      />

      <Box mt={2} mb={2}>
        {tags.map((tag) => (
          <Chip
            key={tag}
            label={tag === "Featured" ? "All" : tag}
            clickable
            onClick={() => handleTagChange(tag)}
            color={selectedTag === tag ? "primary" : "default"}
            sx={{ marginRight: 1, marginBottom: 1 }}
          />
        ))}
      </Box>

      {filteredRecipes.length === 0 ? (
        <Typography variant="h6" align="center" color="textSecondary">
          No results found.
        </Typography>
      ) : (
        <Grid container spacing={4}>
          {filteredRecipes.map((recipe) => (
            <Grid item xs={12} md={3} key={recipe._id}>
              <RecipeCard recipe={recipe} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  )
}

export default SearchPage
